<whats-new [slides]="data.slides" (done$)="dismiss()"></whats-new>
